import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {LEGACY_FONT_PROXIMA_13} from 'styles/FontConstants';

interface DNASearchExampleProps {
  searchQuery: string;
  explanation: string;
}
function DNASearchExample({searchQuery, explanation}: DNASearchExampleProps): JSX.Element {
  return (
    <div className={css(styles.example)}>
      <pre className={css(styles.searchQuery)}>{searchQuery}</pre>
      <span className={css(styles.explanation)}>{explanation}</span>
    </div>
  );
}

export default function DNASearchExamples(): JSX.Element {
  return (
    <>
      <DNASearchExample searchQuery="GATT" explanation="Search bases" />
      <DNASearchExample searchQuery="NGG" explanation="Search with degenerate bases" />
      <DNASearchExample searchQuery="Exon 9" explanation="Annotation/primer name" />
      <DNASearchExample searchQuery=":100" explanation="Jump to base" />
      <DNASearchExample searchQuery=":100:125" explanation="Select range" />
      <DNASearchExample searchQuery=":385:385+26*3" explanation="Select using formula" />
    </>
  );
}

const styles = StyleSheet.create({
  example: {
    marginBottom: 8,
    marginTop: 8,
  },
  searchQuery: {
    display: 'inline',
    padding: 2,
  },
  explanation: {
    ...LEGACY_FONT_PROXIMA_13,
    marginLeft: 4,
  },
});
